import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Box,
  Button,
  Modal,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';

import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// components
import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
// sections
import { ContactListHead } from '../../sections/@dashboard/contact';
import { useDispatch } from 'react-redux';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Course Name', alignRight: false },
  { id: 'by', label: 'Teacher Name', alignRight: false },
  { id: 'duration', label: 'Duration', alignRight: false },
  { id: 'coursePrice', label: 'Course Price', alignRight: true },
  { id: 'actions', label: 'Actions', alignRight: true },
];

export default function CoursePage() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [getCourses, setGetCourses] = useState([]);

  const [deleteId, setDeleteId] = useState();
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);
  const [snackBarOpen1, setSnackBarOpen1] = React.useState(false);
  const [snackBarOpen3, setSnackBarOpen3] = React.useState(false);

  const handleClickSnack = () => {
    setSnackBarOpen(true);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBarOpen(false);
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Fetch all courses
  const getAllCourses = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER}/api/courses/admin`);
      if (response && response.data) {
        setGetCourses(response.data);
      } else {
        console.log('Error in Fetching All Courses');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCourses();
  }, []);

  const handleDeleteModal = async (e, id) => {
    e?.stopPropagation();
    setDeleteId(id);
    try {
      const disableCourse = await axios.delete(`${process.env.REACT_APP_SERVER}/api/courses/${id}`);
      if (disableCourse) {
        setSnackBarOpen3(true);
        getAllCourses();
      } else {
        console.log('Error in Deleting Course');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEnableModal = async (e, id, isDisabled) => {
    try {
      // Toggle the course enabled/disabled based on the current state
      const action = isDisabled ? 'enable' : 'disable'; // Toggle between enable/disable
      const toggleCourse = await axios.put(`${process.env.REACT_APP_SERVER}/api/courses/${action}/${id}`);

      if (toggleCourse) {
        setSnackBarOpen(true);
        getAllCourses();
      } else {
        console.log(`Error in ${action === 'enable' ? 'Enabling' : 'Disabling'} Course`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = getCourses.map((course) => course._id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleUpdateModal = (e, id) => {
    e?.stopPropagation();
    navigate(`/new/course/${id}`);
  };

  const handleApproveModal = async (e, id) => {
    try {
      const response = await axios.put(`${process.env.REACT_APP_SERVER}/api/courses/approve/${id}`);
      if (response.status === 200) {
        // Handle success (e.g., update state, show success message)
        console.log('Course approved successfully');
        setSnackBarOpen(true); // assuming you have a snackbar state
        getAllCourses(); // to refresh the course list
      }
    } catch (error) {
      console.error('Error approving course:', error);
      // Optionally handle the error (e.g., show a snackbar with the error message)
    }
  };

  const NavigateCourse = () => {
    navigate('/new/course');
  };

  const handleClick = (event, id) => {
    event.stopPropagation();
    const selectedIndex = selected.indexOf(id);
    let newSelected = [...selected];
    if (selectedIndex === -1) {
      newSelected.push(id);
    } else {
      newSelected.splice(selectedIndex, 1);
    }
    setSelected(newSelected);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - getCourses.length) : 0;

  const isNotFound = !getCourses.length && !!filterName;

  const displayData = getCourses
    .filter((course) => course.name.toLowerCase().includes(filterName.toLowerCase()))
    .sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];
      return order === 'asc' ? (aValue > bValue ? -1 : 1) : aValue < bValue ? -1 : 1;
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const detailsPage = (id) => {
    navigate(`/course/details/${id}`);
  };

  return (
    <>
      <Helmet>
        <title> Courses </title>
      </Helmet>

      <Container maxWidth="false">
        <Stack
          sx={{
            flexDirection: {
              lg: 'row',
              md: 'row',
              sm: 'row',
              xs: 'column',
            },
          }}
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom sx={{ fontFamily: 'Open Sans', fontWeight: '600' }}>
            Courses
          </Typography>
          <Button
            onClick={NavigateCourse}
            variant="contained"
            sx={{
              padding: { xs: '8px 10px', md: '8px 22px' },
              fontSize: { xs: '12px', md: '16px' },
              borderRadius: '35px',
              fontFamily: 'Open Sans',
              fontWeight: '500',
            }}
            startIcon={<Iconify width={15} icon="eva:plus-fill" />}
          >
            Add Course
          </Button>
        </Stack>

        <Card sx={{ borderRadius: '12px' }}>
          <Scrollbar>
            <TableContainer sx={{ overflow: 'visible' }}>
              <Table>
                <ContactListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={getCourses.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {displayData.map((course, index) => {
                    const { _id, name, by, duration, coursePrice, isDisabled, isApproved } = course;
                    const isSelected = selected.indexOf(_id) !== -1;

                    return (
                      <TableRow hover key={index} tabIndex={-1} role="checkbox" selected={isSelected}>
                        <TableCell padding="checkbox">
                          <Checkbox checked={isSelected} onChange={(event) => handleClick(event, _id)} sx={{ mr: 4 }} />
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{ cursor: 'pointer', fontFamily: 'Open Sans', fontWeight: '600' }}
                          // onClick={() => detailsPage(_id)}
                        >
                          {name}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{ cursor: 'pointer', fontFamily: 'Open Sans', fontWeight: '400' }}
                          // onClick={() => detailsPage(_id)}
                        >
                          {by}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{ cursor: 'pointer', fontFamily: 'Open Sans', fontWeight: '400' }}
                          // onClick={() => detailsPage(_id)}
                        >
                          {duration}
                        </TableCell>
                        <TableCell align="right" sx={{ fontFamily: 'Open Sans', fontWeight: '400' }}>
                          {coursePrice}
                        </TableCell>
                        <TableCell align="right">
                          <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center">
                            {/* Conditionally show Enable/Disable button */}
                            <MenuItem
                              onClick={(e) => handleEnableModal(e, _id, isDisabled)}
                              sx={{ color: isDisabled ? 'success.main' : 'warning.main' }}
                            >
                              <Iconify icon={isDisabled ? 'eva:unlock-outline' : 'eva:lock-outline'} />
                              {isDisabled ? 'Enable' : 'Disable'}
                            </MenuItem>

                            {/* Conditionally show Approve button if not approved */}
                            {!isApproved && (
                              <MenuItem onClick={(e) => handleApproveModal(e, _id)} sx={{ color: 'info.main' }}>
                                <Iconify icon="eva:checkmark-circle-2-outline" />
                                Approve
                              </MenuItem>
                            )}

                            {/* Always show delete button */}
                            <MenuItem onClick={(e) => handleDeleteModal(e, _id)} sx={{ color: 'error.main' }}>
                              <Iconify icon="eva:trash-2-outline" />
                            </MenuItem>

                            {/* Update button */}
                            <MenuItem onClick={(e) => handleUpdateModal(e, _id)} sx={{ color: 'info.main' }}>
                              <Iconify icon="eva:edit-outline" />
                            </MenuItem>
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={TABLE_HEAD.length} sx={{ py: 3 }}>
                        <Paper sx={{ textAlign: 'center' }}>
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={getCourses.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={1000}
        onClose={handleClose}
        message="Course Enabled Successfully"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      <Snackbar
        open={snackBarOpen1}
        autoHideDuration={1000}
        onClose={handleClose}
        message="Course Disabled Successfully"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      <Snackbar
        open={snackBarOpen3}
        autoHideDuration={1000}
        onClose={handleClose}
        message="Course Deleted Successfully"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </>
  );
}
